import React from 'react';
//CSS
import styles from './Formats.module.css';
//Components
//Data

type BulletPointListProps = {
    title?: string,
    items: string[],
    footer?: string,
    header?: string
};

const BulletPointList = ({ title, items, footer, header } : BulletPointListProps) => {
  return (
    <div className={styles.container}>
        <h4 className={styles.title}>{title}</h4>
        {header && <h4 className={styles.header}>{header}</h4>}
        <ul className={styles.list}>
            {items.map((item, index) => {
                return <li key={index} className={styles.item}>{item}</li>
            })}
        </ul>
        {footer && <p className={styles.footer}>{footer}</p>}
    </div>
  );
};

export default BulletPointList;